<template>
  <div v-on:scroll.passive="onScroll" class="el-tabs__content" style="overflow-anchor:none">
    <div role="tree" class="el-tree">
      <TreeNode v-for="(node, index) in root" :key="index" :node="node" :root="root" :level="0"
                :selector="selector" :treeInfo="treeInfo" :enableSelected="enableSelected" :clickCallback="nodeClickCallback"/>
      <div class="el-tree__drop-indicator" style="display: none;"></div>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import TreeNode from "./TreeNode";
import TreeUtil from "./TreeUtil";

export default {
    name: "TreeView",
    components: {
        TreeNode,
    },

    props: {
        root: Array,                //根节点，支持多个
        selector: Object,           //保存节点选择相关信息
        clickCallback: Function,    //点击节点事件
        enableSelected: {type: Boolean, default: true}
    },

    data: function () {
        return {
            treeInfo: {
                scrollRange: {x: 0, y: TreeUtil.Constant.NODE_SCROLL_WINDOW_COUNT},  //滚动窗口逻辑显示区域
            },
            localConfigSetting: {},
            organizationPriv: true,
            exterContactsPriv: true,
            maillistPriv: true
        };
    },

    computed: {},

    methods: {
        onScroll: (function () {
            const headCount = Math.floor((TreeUtil.Constant.NODE_SCROLL_WINDOW_COUNT - TreeUtil.Constant.NODE_SCROLL_VISIBLE_COUNT) / 2); //顶尾预留
            return _.throttle(function (event) {
                const scrollRange = this.treeInfo.scrollRange;
                const range = TreeUtil.getScrollVisibleRange(event.target.scrollTop);

                //窗口挄量内不需要重算
                if (range.x >= scrollRange.x + 10 && range.y <= scrollRange.y - 10) {
                    return;
                }

                //计算滑动窗口区域开始位置
                let x = Math.max(0, Math.floor(event.target.scrollTop / TreeUtil.Constant.NODE_HEIGHT) - headCount);         //顶部
                x = Math.max(Math.min(x, this.root[this.root.length - 1].range.y - TreeUtil.Constant.NODE_SCROLL_WINDOW_COUNT + 1), 0); //底部
                if (this.treeInfo.scrollRange.x === x) {
                    return;
                }

                //先张后缩
                if (x < scrollRange.x) {
                    scrollRange.x = x;
                    scrollRange.y = x + TreeUtil.Constant.NODE_SCROLL_WINDOW_COUNT;
                } else {
                    scrollRange.y = x + TreeUtil.Constant.NODE_SCROLL_WINDOW_COUNT;
                    scrollRange.x = x;
                }
            }, 200, {'leading': false});
        })(),

        nodeClickCallback (node) {
            this.$store.commit('SET_TREE_VIEW_LAST_CLICK_NODE_ID', node.id);
            if (this.clickCallback) {
                this.clickCallback(node);
            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/core/tree/TreeView.vue